/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Budget } from './';
import {
    BudgetFromJSON,
    BudgetFromJSONTyped,
    BudgetToJSON,
} from './';
import type { DailyRate } from './';
import {
    DailyRateFromJSON,
    DailyRateFromJSONTyped,
    DailyRateToJSON,
} from './';
import type { FinanceType } from './';
import {
    FinanceTypeFromJSON,
    FinanceTypeFromJSONTyped,
    FinanceTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface Finance
 */
export interface Finance {
    /**
     * 
     * @type {FinanceType}
     * @memberof Finance
     */
    type: FinanceType;
    /**
     * 
     * @type {string}
     * @memberof Finance
     */
    currencyCode: string;
}

/**
 * Check if a given object implements the Finance interface.
 */
export function instanceOfFinance(value: object): value is Finance {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    return true;
}

export function FinanceFromJSON(json: any): Finance {
    return FinanceFromJSONTyped(json, false);
}

export function FinanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Finance {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['type'] === 'BUDGET') {
            return BudgetFromJSONTyped(json, true);
        }
        if (json['type'] === 'DAILY_RATE') {
            return DailyRateFromJSONTyped(json, true);
        }
    }
    return {
        
        'type': FinanceTypeFromJSON(json['type']),
        'currencyCode': json['currencyCode'],
    };
}

export function FinanceToJSON(value?: Finance | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
        if (value.type === 'BUDGET') {
            return BudgetToJSON(value as Budget);
        }
        if (value.type === 'DAILY_RATE') {
            return DailyRateToJSON(value as DailyRate);
        }
    }
    return {
        
        'type': FinanceTypeToJSON(value['type']),
        'currencyCode': value['currencyCode'],
    };
}

